export const components = {
  header: 64,
  footer: 64,
  sidebar: 64,
};
